<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Filiais Selecionadas</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <md-chip
                        v-for="branch in selectedItems"
                        :key="branch.id"
                        @md-delete="remove(branch)"
                        md-deletable
                        >
                        {{branch.name ? branch.name : "SEM NOME ("+branch.id+")"}} {{branch.id}}
                    </md-chip>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Árvore de Sortimento</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <v-draggable-treeview
                        v-model="treeData"
                        :editable="false"
                        :checkable="false"
                        :initOpened="true"
                        :openCallback="readTreeChild"
                        :clickCallback="selectTreeChild"
                        :selectedId="treeSelectedId"
                        @checked="checkedItem"
                    ></v-draggable-treeview>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Centro de Distribuição</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <md-menu
                        md-size="big"
                        md-direction="top-start"
                        :md-active.sync="togglePlus"
                        :md-close-on-select="false"
                    >
                        <md-button
                            class="md-just-icon md-primary md-simple"
                            md-menu-trigger
                            >
                            <md-icon>add_circle_outline</md-icon>
                        </md-button>
                        <md-menu-content>
                            <div class="md-layout">
                                <div
                                    class="md-layout-item md-size-100">
                                    <md-field>
                                        <label>Buscar filial</label>
                                        <md-input 
                                            v-model="searchName"
                                            @keyup="searchBranch" />
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-size-100"
                                    style="text-align: center">
                                    <md-list
                                        v-if="branches.results.length > 0"
                                        >
                                        <md-list-item 
                                            v-for="branch in branches.results"
                                            :key="branch.id"
                                            @click="selectNewDC(branch)"
                                            >
                                            {{branch.name}}
                                        </md-list-item>
                                    </md-list>
                                    <span
                                        v-if="branches.results.length <= 0 && !branchesReading"
                                        class="md-caption"
                                        >
                                        Não encontrou filial com esse nome!
                                    </span>
                                </div>
                                <div
                                    class="md-layout-item md-size-100"
                                    style="text-align: center;"
                                    >
                                    <md-progress-spinner 
                                        :md-diameter="20" 
                                        :md-stroke="3" 
                                        md-mode="indeterminate"
                                        v-if="branchesReading"></md-progress-spinner>
                                    <md-button
                                        class="md-simple"
                                        v-if="branches.next != null && !branchesReading"
                                        @click="moreBranches()"
                                        >
                                        Mais filiais
                                    </md-button>
                                </div>
                            </div>
                        </md-menu-content>
                    </md-menu>
                    <draggable
                        :list="relationships"
                        :disabled="false"
                        class="list-group"
                        ghost-class="ghost"
                        :key="listCountKey"
                        @start="dragging = true"
                        @end="dragging = false"
                    >
                        <div
                            class="list-group-item"
                            v-for="(element, index) in parents"
                            :key="element.id"
                        >
                            <span
                                style="position: relative; line-height: 41px;height: 41px;">
                                <b>
                                {{index + 1}}º
                                </b>
                            </span>
                            <md-button
                                class="md-just-icon md-simple m-0"
                                 :md-ripple="false"
                                v-bind:disabled="index == 0"
                                @click="moveRelationshipUp(index)"
                                >
                                <i class="fa fa-caret-up" aria-hidden="true" />
                            </md-button>
                            <md-button
                                class="md-just-icon md-simple m-0 p-0"
                                :md-ripple="false"
                                v-bind:disabled="index == parents.length - 1"
                                @click="moveRelationshipDown(index)">
                                <i class="fa fa-caret-down" aria-hidden="true" />
                            </md-button>
                            <span 
                                style="position: relative; line-height: 41px;height: 41px;">
                                {{ element.name }}
                            </span>
                            <md-button
                                class="float-right md-just-icon md-danger md-simple m-0"
                                @click="removeRelationship(element.id)">
                                <md-icon>close</md-icon>
                            </md-button>
                            
                            <md-divider></md-divider>
                        </div>
                    </draggable>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-100">
            <md-button
                class="mr-1"
                @click="$router.go(-1)"
                >
                Voltar
            </md-button>
            <md-button
                class="md-primary"
                @click="save()">
                Salvar
            </md-button>
        </div>
        
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'
import { VuetifyDraggableTreeview } from '@/components'
import draggable from 'vuedraggable'
import { Branch as Model } from '@/models/branch.model'

import _ from 'lodash'
const model = 'branches'

export default {
    created() {
        this.clearRelationships()
        this.readTreeNodes({})
    },
    components: {
        'v-draggable-treeview': VuetifyDraggableTreeview,
        draggable,
    },
    computed: {
        ...mapState({
            branches: state => state[model].page,
            branchesReading: state => state[model].reading,
            selectedItems: state => state[model].selectedItems,
            relationships: state => state[model].relationships,
            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors,
        }),

        treeData() {
            return [{ name: 'Todos os itens', id: null}] //this.treePage.results
        },

        parents() {
            let parents = []
            this.relationships.forEach(relationship => {
                if(parents.filter(parent => parent.id === relationship.parent.id).length <= 0
                   && relationship.active)
                    parents.push(relationship.parent)
            })
            return parents
        }

    },
    data() {
        return {
            togglePlus: false,
            searchedBranch: [],
            searchName: null,
            selectedNode: null,
            deletedDcs: [],
            listCountKey: 0,
            treeSelectedId: 0
        }
    },
    methods: {
        ...mapActions(model, {
            selectItems: 'selectItems',
            readRelationships: 'readRelationships',
            readBranches: 'read',
            readMoreBranches: 'more',
            saveRelationships: 'saveRelationships',
            clearRelationships: 'clearRelationships'
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),

        remove(item) {
            let index = this.selectedItems.findIndex(e=>e.id == item.id)
            if(index > -1)
                this.selectedItems.splice(index, 1)
        },


        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },
        async selectTreeChild(item) {
            this.treeSelectedId = item.id
            if(!this.selectedItems || this.selectedItems.length <= 0) {
                this.$notify({
                    message: 'Não há filiais selecionadas',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }
            this.selectedNode = item
            if(this.selectedItems.length!==1) {
                this.clearRelationships()
                return
            }
            let args = {
                branch: this.selectedItems[0].id,
                node: item.id
            }
            await this.readRelationships(args)
            this.deletedDcs = []
        },

        checkedItem(value) {
            var leafA = this.treeData
            var leafB = value

            var found = false
            var node = null;

            while(!found) {
                leafA.every(elem => {
                    if(elem.id == leafB.id) {
                        node = elem
                        return false
                    }
                    return true
                })

                if(leafB.child) {

                    leafB = leafB.child
                    leafA = node.children

                } else {

                    found = true
                }
    
            }

            if(!leafB.checked) return

            if(this.selectedItems.length!==1) return

            let args = {
                branch: this.selectedItems[0].id,
                node: node.id
            }
            this.readRelationships(args)
        },

        removeRelationship(parent_id) {
            this.relationships.filter(rel=>rel.parent.id == parent_id).forEach(rel=>{
                rel.active = false
            })
            this.clearRelationships(this.relationships.filter(rel=>rel.parent.id !== parent_id || rel.id))
            
        },

        moveRelationshipUp(index) {
            this.array_move(this.relationships, index, index - 1)

        },
        moveRelationshipDown(index) {
            this.array_move(this.relationships, index, index + 1)

        },
        array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        },

        searchBranch: _.debounce(function(e) {
            let args = {
                limit: 5,
                branch: e.target.value,
            }
            this.readBranches(args)
        }, 500),

        moreBranches: _.debounce(function(e) {
            this.readMoreBranches(this.branches.next)
        }, 100),

        selectNewDC(dc) {

            if(this.relationships.filter(relationship=>relationship.parent.id === dc.id).length > 0) return

            if(!this.selectedNode) {

                this.$notify({
                    message: 'Selecione um nó na árvore de sortimento.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }

            this.selectedItems.forEach(child => {
                this.relationships.push({
                    id: null,
                    parent: {
                        id: dc.id,
                        external_id: dc.external_id,
                        name: dc.name
                    },
                    child: {
                        id: child.id,
                        external_id: child.external_id,
                        name: child.name
                    },
                    node: {
                        id: this.selectedNode.id,
                        external_id: this.selectedNode.external_id
                    },
                    active: true
                })
            })

            this.togglePlus = false
        },

        async save() {
            if(!this.selectedNode) {
                this.$notify({
                    message: 'Selecione um nó na árvore de sortimento.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }

            if(!this.selectedItems || this.selectedItems.length <= 0) {
                this.$notify({
                    message: 'Não há filiais selecionadas.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }

            if(!this.parents || this.parents.length <= 0) {
                this.$notify({
                    message: 'Não há relações para salvar.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return

            }

            let relationships = []

            if(this.relationships.filter(rel => rel.id).length > 0) {
                relationships = this.relationships.map((rel, index) => {
                    rel.order_priority = index
                    return rel
                })
            } else {
                relationships = this.relationships.map(rel => {
                    rel.order_priority = 9999
                    return rel
                })
            }


            if(relationships.length <=  0) return
            
            let response = await this.saveRelationships(relationships)
            if(response === 400) {
                this.$notify({
                    message: 'Alguma relação já existe.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })

            }
            else if(response) {
                this.$notify({
                    message: 'Erro ao salvar relações.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            } else {
                this.$notify({
                    message: 'Relações salva com sucesso.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })

            }
            this.selectTreeChild(this.selectedNode)

        }


    }
}
</script>
<style scoped>
.md-menu-content {
    min-height: auto;
    max-height: 500px;
}
</style>